import { EMPTY_STRING } from "../../../shared/constants/client";

export interface FilterOptions {
  id: number;
  property: string;
  text: string;
}

export const defaultRowsPerPageOptions = [5, 10, 25];

export const sortOptions = [
  { key: EMPTY_STRING, text: "None" },
  { key: "applicationName_asc", text: "By Application Name asc" },
  { key: "applicationName", text: "By Application Name dsc" },
  { key: "userGroupName_asc", text: "By User Group Name asc" },
  { key: "userGroupName", text: "By User Group Name dsc" },
  { key: "debtorGroupName_asc", text: "By Debtor Group Name asc" },
  { key: "debtorGroupName", text: "By Debtor Group Name dsc" },
];

export const dynamicFilterOptions: FilterOptions[] = Object([
  { id: 1, property: "userGroupName", text: "By User Group Name" },
  { id: 2, property: "debtorGroupName", text: "By Debtor Group Name" },
]);
